if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, originalAtcBtnId = '', linkToOriginalAtc = false) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        showStickyATC: false,
        mainAtcVisible: false,
        footerVisible: false,
        atcObserver: null,
        footerObserver: null,
        init() {
          this.initVisibilityObservers();
          this.syncLinkedAtcButton();

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            this.syncLinkedAtcButton(e.detail.html);
            this.updateStickyVisibility();
          });
        },
        destroy() {
          this.atcObserver?.disconnect();
          this.footerObserver?.disconnect();
        },
        initVisibilityObservers() {
          const originalAtcBtn = document.getElementById(originalAtcBtnId);
          if (originalAtcBtn) {
            this.atcObserver = new IntersectionObserver(() => {
              this.updateStickyVisibility();
            }, {
              threshold: 0.01
            });

            this.atcObserver.observe(originalAtcBtn);
          }

          const footer = document.getElementById('section-footer');
          if (footer) {
            this.footerObserver = new IntersectionObserver(() => {
              this.updateStickyVisibility();
            }, {
              threshold: 0.01
            });

            this.footerObserver.observe(footer);
          }

          this.updateStickyVisibility();
        },
        isVisible(element) {
          if (!element) return false;

          const styles = window.getComputedStyle(element);
          return styles.display !== 'none'
            && styles.visibility !== 'hidden'
            && styles.opacity !== '0'
            && !(element.offsetWidth === 0 && element.offsetHeight === 0);
        },
        isInViewport(element) {
          if (!this.isVisible(element)) return false;

          const rect = element.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

          return rect.bottom > 0
            && rect.right > 0
            && rect.top < viewportHeight
            && rect.left < viewportWidth;
        },
        updateStickyVisibility() {
          const originalAtcBtn = document.getElementById(originalAtcBtnId);
          const footer = document.getElementById('section-footer');

          this.mainAtcVisible = this.isInViewport(originalAtcBtn);
          this.footerVisible = this.isInViewport(footer);
          this.showStickyATC = !this.footerVisible && !this.mainAtcVisible;
        },
        syncLinkedAtcButton(sourceRoot = document) {
          if (!linkToOriginalAtc) return;

          const stickyButton = document.getElementById(`x-atc-button-sticky-linked-${sectionId}`);
          if (!stickyButton) return;

          let originalAtcBtn = sourceRoot.getElementById?.(originalAtcBtnId);
          if (!originalAtcBtn) originalAtcBtn = document.getElementById(originalAtcBtnId);
          if (!originalAtcBtn) return;

          const stickyLabel = stickyButton.querySelector('.x-atc-text');
          const originalLabel = originalAtcBtn.querySelector('.x-atc-text');
          if (stickyLabel && originalLabel) {
            stickyLabel.innerHTML = originalLabel.innerHTML;
          }

          if (originalAtcBtn.hasAttribute('disabled')) {
            stickyButton.setAttribute('disabled', 'disabled');
          } else {
            stickyButton.removeAttribute('disabled');
          }
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}
